import React, { useState, useEffect } from "react";
import NavbarDashboard from "../../../components/Navbar/NavbarDashboard";
import { Link } from "react-router-dom";
import fundamentals_icon from "../../../assets/images/icon_fundamentals.png";
import "../../../styles/style_label.css";
import LinearProgress from "@mui/joy/LinearProgress";
import Typography from "@mui/joy/Typography";
import { firebase, doc, db, getDoc, auth } from "../../../firebase";
import "firebase/compat/firestore";
import { IoChevronBackOutline } from "react-icons/io5";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../../../styles/tabs.css";

function Progress() {
  let nbsp = "\u00a0";

  // Step 2: Initialize a state variable
  const [quizFinishedValueWarning, setQuizFinishedValue] = useState(0);
  const [quizFinishedValueRegulatory, setQuizFinishedValue2] = useState(0);
  const [quizFinishedValueInformative, setQuizFinishedValue3] = useState(0);
  const [quizFinishedValueDashed, setQuizFinishedValue4] = useState(0);
  const [quizFinishedValuePavement, setQuizFinishedValue5] = useState(0);
  const [quizFinishedValueDouble, setQuizFinishedValue6] = useState(0);
  const [quizFinishedValueCrosswalk, setQuizFinishedValue7] = useState(0);
  const completedStyle = { color: "green" };
  const notStartedStyle = { color: "red" };

  const getQuizFinishedStatusWarning = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "warning", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  const getQuizFinishedStatusRegulatory = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "regulatory", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue2(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  const getQuizFinishedStatusInformative = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "informative", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue3(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };
  const getQuizFinishedStatusWhite = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "whiteline", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue4(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };
  const getQuizFinishedStatusPavement = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "pavement", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue5(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };
  const getQuizFinishedStatusDouble = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "double", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue6(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  const getQuizFinishedStatusCrosswalk = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "crosswalk", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue7(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  useEffect(() => {
    getQuizFinishedStatusWarning();
  }, []); //

  useEffect(() => {
    getQuizFinishedStatusRegulatory();
  }, []);

  useEffect(() => {
    getQuizFinishedStatusInformative();
  }, []);

  useEffect(() => {
    getQuizFinishedStatusWhite();
  }, []); //

  useEffect(() => {
    getQuizFinishedStatusPavement();
  }, []);

  useEffect(() => {
    getQuizFinishedStatusDouble();
  }, []);

  useEffect(() => {
    getQuizFinishedStatusCrosswalk();
  }, []);

  const quizStatusTextWarning =
    quizFinishedValueWarning === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const quizStatusTextRegulatory =
    quizFinishedValueRegulatory === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const quizStatusTextInformative =
    quizFinishedValueInformative === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const quizStatusTextDashed =
    quizFinishedValueDashed === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const quizStatusTextPavement =
    quizFinishedValuePavement === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const quizStatusTextDouble =
    quizFinishedValueDouble === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const quizStatusTextCrosswalk =
    quizFinishedValueCrosswalk === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const [activeTab, setActiveTab] = useState(1); // Default to the first tab

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="container-dashboard">
      <NavbarDashboard />

      <div className="container-main-contents">
        <div className="container-main-header">
          <div className="container-main-header-title">
            <Link class="back-button" to={"/"}>
              <IoChevronBackOutline />
            </Link>
            <h1>TRAFFIC SIGNS AND ROAD MARKINGS</h1>
          </div>

          <p>
            Traffic signs and road markings are integral elements of road
            infrastructure, playing a pivotal role in ensuring the safety and
            orderliness of road systems. Their importance lies in their ability
            to communicate vital information to drivers, pedestrians, and
            cyclists, serving as a universal language of road etiquette. By
            regulating traffic flow, these signs and markings provide clear
            instructions on speed limits, right of way, and other crucial
            guidelines, contributing to the prevention of accidents and the
            overall safety of road users.
          </p>
        </div>
        <div className="lesson-content">
          <Tabs>
            <TabList className="tab-selector">
              <Tab
                onClick={() => handleTabClick(1)}
                className={activeTab === 1 ? "active-tab tab-ind" : "tab-ind"}
              >
                <h1>Traffic Signs</h1>
              </Tab>

              <Tab
                onClick={() => handleTabClick(2)}
                className={activeTab === 2 ? "active-tab tab-ind" : "tab-ind"}
              >
                <h1>Road Markings</h1>
              </Tab>
            </TabList>

            {activeTab === 1 && (
              <div className="lesson-selection">
                <div className="lesson-selection-card">
                  <h4>Warning</h4>
                  <Link to="/ts_warning">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusTextWarning}</p>
                </div>
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Regulatory</h4>
                  <Link to="/ts_regulatory">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusTextRegulatory}</p>
                </div>
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Informative</h4>
                  <Link to="/fundamentals_braking">
                    <Link to="/ts_informative">
                      <p className="start-learning">Start Learning</p>
                    </Link>
                  </Link>
                  <p>{quizStatusTextInformative}</p>
                </div>
              </div>
            )}

            {activeTab === 2 && (
              <div className="lesson-selection">
                <div className="lesson-selection-card">
                  <h4>Dashed White Line</h4>
                  <Link to="/ts_whiteline">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusTextDashed}</p>
                </div>
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Pavement Arrows</h4>
                  <Link to="/ts_pavement">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusTextPavement}</p>
                </div>
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Double Solid Yellow Lane</h4>
                  <Link to="/ts_double">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusTextDouble}</p>
                </div>
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Crosswalks</h4>
                  <Link to="/fundamentals_braking">
                    <Link to="/ts_crosswalks">
                      <p className="start-learning">Start Learning</p>
                    </Link>
                  </Link>
                  <p>{quizStatusTextCrosswalk}</p>
                </div>
              </div>
            )}

            {activeTab === 3 && (
              <div className="lesson-selection">
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Test</h4>
                  <p className="start-learning">Start Learning</p>
                  <p>{quizStatusTextCrosswalk}</p>
                </div>
              </div>
            )}

            {/* <TabPanel>
              <h2>Basics Page</h2>
            </TabPanel>
            <TabPanel>
              <h2>Additinals Page</h2>
            </TabPanel>
            <TabPanel>
              <h2>Quizzes Page</h2>
            </TabPanel> */}
          </Tabs>
        </div>
      </div>
    </div>
  );
}
export default Progress;
